<template>
	<portal to="main">
		<slot></slot>
	</portal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class Main extends Vue {
}
</script>